import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import success from "../assets/images/exito-2.png";
import QuizCertificate from "./QuizCertificate";
import { navigate } from "@reach/router";

const QuizApproved = ({ attempt, course, test }) => {
  const { user } = useContext(AuthContext);

  const renderButton = () => {
    if (test.course_id === null && course && course !== null) {
      return (
        <div className="d-flex h-100 flex-column justify-content-center">
          <button
            onClick={() => navigate(`/mytbm/course/${course.course_id}`)}
            className="btn shadow bg-dark btn-quiz"
          >
            Continuar con siguiente módulo
          </button>
        </div>
      );
    }
  };

  return (
    <div className="col-12 ps-5 px-5 mt-5 mb-5 d-flex flex-column justify-content-end align-items-center">
      <div className="d-flex h-100 flex-column justify-content-center align-items-center col-12">
        <div className="d-flex h-100 flex-column justify-content-center align-items-center col-12">
          <img src={success} className="col-lg-1 col-4" alt="felicidades" />
        </div>
        <div className="d-flex h-100 flex-column justify-content-center align-items-center col-12 mt-lg-5 mt-3  mb-3">
          <span className="bold text-center text-primary h1">
            ¡Felicidades {user.name}!
          </span>
        </div>
        <div className="d-flex h-100 flex-column justify-content-center align-items-center col-12 mb-5 mt-3 ps-5 px-5">
          <span className="text-center h4 bold">
            Has aprobado el {test.course_id !== null ? "" : "quiz"} {test.name}.
          </span>
        </div>
        <div className="container-fluid text-center">
          <h4 className="bold">Calificación</h4>
          <p className="display-3 fw-normal">{attempt.score}</p>
        </div>
        {renderButton()}
      </div>
      {test.course_id && test.course_id !== null && (
        <div className="container" style={{ maxWidth: 700 }}>
          <QuizCertificate course={course} attempt={attempt} test={test} />
        </div>
      )}
    </div>
  );
};

export default QuizApproved;
